export class AuthFetchError extends Error {
  readonly status: number;
  constructor(message: string, readonly response: Response) {
    super(message);
    this.name = 'AuthFetchError';
    this.status = response.status;
  }
}

